module.exports = __webpack_public_path__ + "img/not-found.ac03ddd2.svg";